export default "__VITE_ASSET__CtW0wuki__"